import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FILTER_TEMPLATES, FilterBarService } from '@modules/filters/filter-bar.service';
import { FilterButtonsComponent } from '@modules/filters/filter-buttons/filter-buttons.component';
import { SadmClientActionButtonComponent } from '@modules/sadm/components/sadm-client-action-button/sadm-client-action-button.component';
import { SadmEntityListComponent } from '@modules/sadm/components/sadm-entity-list/sadm-entity-list.component';
import { SadmAnalysisService } from '@modules/sadm/services/sadm-analysis.service';
import { SadmEntityService } from '@modules/sadm/services/sadm-entity.service';
import { SadmGridService } from '@modules/sadm/services/sadm-grid.service';
import { LoaderComponent } from '@modules/shared/loader/loader.component';
import { Patient } from '@pixacare/domain';
import { SadmClient } from '@pixacare/dtos';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { patientAnalysesFilterTemplates } from '@shared/models/filters/filter-template.config';
import { PatientService } from '../patient/patient.service';
import { PatientAnalysesService } from './patient-analyses.service';
import { TuiAnimated } from '@taiga-ui/cdk';

@Component({
  hostDirectives: [TuiAnimated],
  templateUrl: './patient-analyses.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    SadmAnalysisService,
    SadmEntityService,
    FilterBarService,
    PatientAnalysesService,
    {
      provide: FILTER_TEMPLATES,
      useValue: patientAnalysesFilterTemplates,
    },
  ],
  host: {
    class: 'flex flex-col gap-2',
  },
  imports: [
    TranslocoDirective,
    FilterButtonsComponent,
    AsyncPipe,
    SadmClientActionButtonComponent,
    SadmEntityListComponent,
    EmptyStateComponent,
    LoaderComponent,
  ],
})
export class PatientAnalysesComponent implements OnInit {
  private readonly patientService = inject(PatientService);
  private readonly analysesService = inject(PatientAnalysesService);
  private readonly filterBarService = inject(FilterBarService);
  private readonly sadmGridService = inject(SadmGridService);

  readonly patient$ = this.patientService.getPatient();
  readonly sadms$ = this.analysesService.sadmClients$;
  readonly sadmEntities$ = this.analysesService.sadmEntities$;
  readonly isDataLoaded$ = this.analysesService.isDataLoaded$;

  ngOnInit(): void {
    this.filterBarService.init();
  }

  openSadmGrid(sadmClient: SadmClient, patient: Patient): void {
    this.sadmGridService.openGrid(sadmClient, patient).subscribe();
  }
}
